import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtFR: CultureInfo = {
  name: 'pt-FR',
  displayName: 'português (França)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-FR',
  parent: CultureInfoPt
};
